<template>
    <div class="add-evaluation add-evaluation-result">
        <div class="add-evaluation--rating" :class="ratingExtraClass">
            <div class="add-evaluation--rating--box">
                <EvaluationStar />
            </div>
            <div class="add-evaluation--rating--box">
                <EvaluationStar />
            </div>
            <div class="add-evaluation--rating--box">
                <EvaluationStar />
            </div>
            <div class="add-evaluation--rating--box">
                <EvaluationStar />
            </div>
            <div class="add-evaluation--rating--box">
                <EvaluationStar />
            </div>
        </div>
    </div>
</template>

<script>
    import EvaluationStar from './EvaluationStar'

    export default {
        components: {
            EvaluationStar
        },
        props: {
            ratingExtraClass: {
                type: String
            }
        }
    }
</script>